import { render, staticRenderFns } from "./SetWithdrawAddressMessageDetails.vue?vue&type=template&id=3b481213&"
import script from "./SetWithdrawAddressMessageDetails.vue?vue&type=script&lang=js&"
export * from "./SetWithdrawAddressMessageDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports